import React, {useEffect, useState, useRef} from "react"
import globalMasehtot from "../masehtot.json"
import {useNavigate, useParams} from "react-router-dom";
import HebrewDatePicker from '../../HebrewDatePicker';
import 'react-datepicker/dist/react-datepicker.css';
import {collection, deleteDoc, doc, getDoc, getDocs, updateDoc, query, setDoc, where} from "firebase/firestore";
import { logEvent } from "firebase/analytics";
import {db, analytics} from "../../index";
import Spinner from "../../spinner";
import {countries, CountryFlag} from "./countriesData";


const EditSium = () => {

    const params = useParams();
    const [sium, setSium] = useState([]);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [errorMessage, setErrorMessage] = useState("");
    const [phone, setPhone] = useState('');
    const [selectedCountry, setSelectedCountry] = useState(countries[0]);
    const [phonePrefix, setPhonePrefix] = useState(countries[0].prefix);
    const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState(false);
    const countryDropdownRef = useRef(null);
    const [haluka, setHaluka] = useState('masehtot');
    const [mishna, setMishna] = useState(false);
    const [hideLomdim, setHideLomdim] = useState(false);
    const [haveChanges, setHaveChanges] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [haveHalukaChanges, setHaveHalukaChanges] = useState(false)
    const [haveIncludeChanges, setHaveIncludeChanges] = useState(false)
    const [backupUsers, setBackupUsers] = useState([])
    const [isRestoringBackup, setIsRestoringBackup] = useState(false)
    const [includeMasehtot, setIncludeMasehtot] = useState({
        shkalim: false,
        kanim: false,
        tamid: false,
        midot: false,
    });
    const navigate = useNavigate();
    const mishnaKeys = [
        "peha", "demai", "kilayim", "sheviit", "trumot", "maasrot", "maaserSheni", "hallah", "orla", "bikurim", "eduyot", "avot",
        "kelim", "ohalot", "negaim", "parah", "taharot", "mikvaot", "machshirin", "zavim", "tvulYom", "yadayim", "uktzin"
    ];

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (countryDropdownRef.current && !countryDropdownRef.current.contains(event.target)) {
                setIsCountryDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleMishnaChange = (mishna) => {
        setMishna(mishna === 'yes');
        setHaveChanges(true);
        setHaveIncludeChanges(true);
    };

    const handleHideLomdimChange = (hide) => {
        setHideLomdim(hide === 'yes');
        setHaveChanges(true);
    };

    const handleCountrySelect = (country) => {
        setSelectedCountry(country);
        setPhonePrefix(country.prefix);
        setIsCountryDropdownOpen(false);
        setHaveChanges(true);
    };

    const handlePrefixChange = (e) => {
        const value = e.target.value.replace(/\D/g, '');
        setPhonePrefix(value);
        setHaveChanges(true);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        logEvent(analytics, 'edit_sium', {
            siumId: params.siumId,
            have_haluka_changes: haveHalukaChanges,
            have_include_changes: haveIncludeChanges
        });

        if (siumValidation()) {
            setHaveChanges(false);
            setIsLoading(true);

            const docRef = doc(db, "siumim", params.siumId);
            let editSium = sium;
            if (sium.kehilaName !== event.target.kehilaName.value) {
                editSium.kehilaName = event.target.kehilaName.value;
            }
            if (sium.organizerName !== event.target.fullName.value) {
                editSium.organizerName = event.target.fullName.value;
            }
            if (sium.organizerPhone !== phone) {
                editSium.organizerPhone = [phone];
            }
            if (sium.organizerEmail !== event.target.email.value) {
                const cleanedEmail = event.target.email.value ? String(event.target.email.value).trim().toLowerCase() : '';
                editSium.organizerEmail = cleanedEmail;
            }
            if (sium.nishmat !== event.target.nishmat.value) {
                editSium.nishmat = event.target.nishmat.value;
            }
            editSium.countryCode = selectedCountry.code;
            editSium.phonePrefix = phonePrefix;
            editSium.includeMishna = mishna;
            editSium.hideLomdim = hideLomdim;

            if (haveHalukaChanges) {
                editSium.haluka = haluka;
                await handleHalukaChange(docRef, editSium);
            } else if (!haveHalukaChanges && haveIncludeChanges) {
                await saveIncludeMasehtot(editSium);
            }

            editSium.startSium = startDate;
            editSium.endSium = endDate;
            setHaveChanges(false);

            setDoc(docRef, editSium).then(() => {
                navigate("/niulSium/" + params.siumId + "/siumStatus");
            }).catch((error) => {
                console.log(`Couldn't save sium element ${error}`)
            });
        }

    }

    async function saveIncludeMasehtot(sium) {
        sium.includeMasehtot = [];
        const masehtot = Object.keys(includeMasehtot);
        let pagesCounter = 0;

        if (haluka === 'dapim') {
            pagesCounter = 2675;
            for (const masehetKey of masehtot) {
                if (includeMasehtot[masehetKey]) {
                    sium.includeMasehtot.push(masehetKey);
                    const currentMasehet = globalMasehtot.allMasehtot[masehetKey];
                    if (currentMasehet && currentMasehet.pagesForDapim) {
                        pagesCounter += currentMasehet.pagesForDapim;
                    }
                    if (!sium.masehtotSelection.some(obj => Object.keys(obj)[0] === masehetKey) && !haveHalukaChanges) {
                        const newEntry = globalMasehtot.newSiumDapim.find(obj => Object.keys(obj)[0] === masehetKey);
                        if (newEntry) {
                            sium.masehtotSelection.push(newEntry);
                        }
                    }
                } else if (!haveHalukaChanges) {
                    sium.masehtotSelection = sium.masehtotSelection.filter(obj => Object.keys(obj)[0] !== masehetKey);
                    await removeMasehetFromUsers(masehetKey);
                }
            }
            if (!haveHalukaChanges) {
                sium.masehtotSelection = sium.masehtotSelection
                    .sort((a, b) => globalMasehtot.allMasehtot[Object.keys(a)[0]].index - globalMasehtot.allMasehtot[Object.keys(b)[0]].index);
            }
        } else {
            pagesCounter = 2906;
            for (const masehetKey of masehtot) {
                if (includeMasehtot[masehetKey]) {
                    sium.includeMasehtot.push(masehetKey);
                    const currentMasehet = globalMasehtot.allMasehtot[masehetKey];
                    if (currentMasehet && currentMasehet.pagesForMasehtot) {
                        pagesCounter += currentMasehet.pagesForMasehtot;
                    }
                    if (sium.masehtotSelection[masehetKey] === undefined && !haveHalukaChanges) {
                        sium.masehtotSelection[masehetKey] = globalMasehtot.masehtotSelection[masehetKey];
                    }
                } else if (!haveHalukaChanges) {
                    delete sium.masehtotSelection[masehetKey];
                    await removeMasehetFromUsers(masehetKey);
                }
            }
        }
        if (mishna) {
            for (const masehetKey of mishnaKeys) {
                if (haluka === 'dapim') {
                    const isExists = sium.masehtotSelection.some(obj => Object.keys(obj)[0] === masehetKey);
                    if (!isExists) {
                        const newEntry = globalMasehtot.newSiumDapim.find(obj => Object.keys(obj)[0] === masehetKey);
                        if (newEntry) {
                            sium.masehtotSelection.push(newEntry);
                        }
                    }
                } else {
                    const isExists = sium.masehtotSelection[masehetKey] !== undefined
                    if (!isExists) {
                        sium.masehtotSelection[masehetKey] = globalMasehtot.masehtotSelection[masehetKey];
                    }
                }
            }
            pagesCounter += 196;
        } else {
            for (const masehetKey of mishnaKeys) {
                if (haluka === 'dapim') {
                    const isExists = sium.masehtotSelection.some(obj => Object.keys(obj)[0] === masehetKey);
                    if (isExists) {
                        sium.masehtotSelection = sium.masehtotSelection.filter(obj => Object.keys(obj)[0] !== masehetKey);
                        await removeMasehetFromUsers(masehetKey);
                    }
                } else {
                    const isExists = sium.masehtotSelection[masehetKey] !== undefined;
                    if (isExists) {
                        delete sium.masehtotSelection[masehetKey];
                        await removeMasehetFromUsers(masehetKey);
                    }
                }
            }
        }
        sium.pagesCounter = pagesCounter;
    }

    function siumValidation() {
        if (startDate && endDate) {
            if (startDate.getTime() < endDate.getTime()) {
                return true;
            }
        }
        setErrorMessage("בחירת תאריכים שגויה");
        const toastModal = document.getElementById('errorModal');
        const toastBootstrap = window.bootstrap.Toast.getOrCreateInstance(toastModal);
        toastBootstrap.show();
    }

    async function removeMasehetFromUsers(masehetKey) {
        const q = query(collection(db, "users"), where("siumId", "==", params.siumId));
        const querySnapshot = await getDocs(q);
        const updatePromises = querySnapshot.docs.map(async (doc) => {
            const userData = doc.data();
            if (haluka === 'dapim') {
                const updatedPages = Object.entries(userData.pages).reduce((acc, [key, value]) => {
                    if (!key.startsWith(masehetKey)) {
                        acc[key] = value;
                    }
                    return acc;
                }, {});

                if (Object.keys(updatedPages).length !== Object.keys(userData.pages).length && Object.keys(updatedPages).length > 0) {
                    await updateDoc(doc.ref, { pages: updatedPages });
                }
                if (Object.keys(updatedPages).length === 0) {
                    await deleteDoc(doc.ref);
                }
            } else {
                const userMasehtot = [];
                for (const masehet of userData.masehtot) {
                    if (masehet.masehetId !== masehetKey) {
                        userMasehtot.push(masehet);
                    }
                }
                if (userMasehtot.length !== userData.masehtot.length && userMasehtot.length > 0) {
                    await updateDoc(doc.ref, { masehtot: userMasehtot });
                }
                if (userMasehtot.length === 0) {
                    await deleteDoc(doc.ref);
                }
            }
        });
        await Promise.all(updatePromises);

    }

    async function handleHalukaChange(docRef, editSium) {
        const q = query(collection(db, "users"), where("siumId", "==", params.siumId));
        const querySnapshot = await getDocs(q);
        logEvent(analytics, 'delete_users', {
            siumId: params.siumId,
            users_counter: querySnapshot.size
        });

        if (querySnapshot.size > 10) {
            const backupPromises = querySnapshot.docs.map(async (userDoc) => {
                const userData = userDoc.data();
                const userId = userDoc.id;

                const userBackupData = {
                    ...userData,
                    createdDate: new Date().getTime()
                };

                const backupDocRef = doc(db, "usersBackup", userId);
                await setDoc(backupDocRef, userBackupData);

                await deleteDoc(userDoc.ref);
            });
            await Promise.all(backupPromises);

        } else {
            const deletePromises = querySnapshot.docs.map((doc) => deleteDoc(doc.ref));
            await Promise.all(deletePromises);
        }

        editSium.includeMasehtot = [];
        let pagesCounter = 0;

        if (haluka === 'masehtot') {
            pagesCounter = 2906;
            let masehetot = {};
            for (const masehetKey of Object.keys(globalMasehtot.masehtotSelection)) {
                const currentMasehet = globalMasehtot.allMasehtot[masehetKey];
                if (currentMasehet.canByChoose === undefined && currentMasehet.isMishna === undefined) {
                    masehetot[masehetKey] = globalMasehtot.masehtotSelection[masehetKey];
                } else if (currentMasehet.isMishna) {
                    if (mishna) {
                        masehetot[masehetKey] = globalMasehtot.masehtotSelection[masehetKey];
                    }
                } else if (includeMasehtot[masehetKey]) {
                    masehetot[masehetKey] = globalMasehtot.masehtotSelection[masehetKey];
                    editSium.includeMasehtot.push(masehetKey);
                    if (currentMasehet && currentMasehet.pagesForMasehtot) {
                        pagesCounter += currentMasehet.pagesForMasehtot;
                    }
                }
            }
            editSium.masehtotSelection = masehetot;
        } else {
            pagesCounter = 2675;
            let masehetot = [];
            globalMasehtot.newSiumDapim.forEach(obj => {
                Object.keys(obj).forEach(key => {
                    const currentMasehet = globalMasehtot.allMasehtot[key];
                    if (currentMasehet.canByChoose === undefined && currentMasehet.isMishna === undefined) {
                        masehetot.push(obj);
                    } else if (currentMasehet.isMishna) {
                        if (mishna) {
                            masehetot.push(obj);
                        }
                    } else if (includeMasehtot[key]) {
                        masehetot.push(obj);
                        editSium.includeMasehtot.push(key);
                        if (currentMasehet && currentMasehet.pagesForDapim) {
                            pagesCounter += currentMasehet.pagesForDapim;
                        }
                    }
                });
            });
            editSium.masehtotSelection = masehetot;
        }
        if (mishna) {
            pagesCounter += 196;
        }
        editSium.pagesCounter = pagesCounter;
    }

    const handlePhoneChange = (e) => {
        const inputValue = e.target.value;
        setHaveChanges(true);
        const numericValue = inputValue.replace(/\D/g, ''); // Remove non-digit characters
        setPhone(numericValue);
    };

    const handleIcludeMasehtot = (e) => {
        setHaveIncludeChanges(true);
        const { id, checked } = e.target;
        setIncludeMasehtot((prev) => ({
            ...prev,
            [id]: checked,
        }));
        setHaveChanges(true);
    };

    useEffect(() => {
        const docRef = doc(db, "siumim", params.siumId);
        getDoc(docRef).then(sium => {
            if (sium && sium.exists()) {
                setSium(sium.data());
                setPhone(sium.data().organizerPhone);
                // Load saved country and prefix
                if (sium.data().countryCode) {
                    const country = countries.find(c => c.code === sium.data().countryCode);
                    if (country) {
                        setSelectedCountry(country);
                        setPhonePrefix(sium.data().phonePrefix || country.prefix);
                    }
                }
                if (sium.data().haluka) {
                    setHaluka(sium.data().haluka);
                }
                if (sium.data().includeMishna) {
                    setMishna(true);
                }
                if (sium.data().hideLomdim) {
                    setHideLomdim(true);
                }
                if (sium.data().includeMasehtot) {
                    let tmpIncludeMasehtot = [];
                    for (const key of sium.data().includeMasehtot) {
                        tmpIncludeMasehtot[key] = true;
                    }
                    setIncludeMasehtot(tmpIncludeMasehtot);
                }
                setStartDate(sium.data().startSium?.toDate());
                setEndDate(sium.data().endSium?.toDate());

                // Fetch backup users
                fetchBackupUsers(sium.data().haluka);
            } else {
                navigate("/");
            }

        });
    },[params.siumId]);

    // Fetch backup users from usersBackup collection (only if no existing users)
    const fetchBackupUsers = async (siumHaluka) => {
        try {
            // First check if there are existing users for this sium
            const usersQuery = query(
                collection(db, "users"),
                where("siumId", "==", params.siumId)
            );
            const usersSnapshot = await getDocs(usersQuery);

            // Only look for backup users if there are no existing users
            if (usersSnapshot.docs.length > 0) {
                setBackupUsers([]);
                return;
            }

            const backupQuery = query(
                collection(db, "usersBackup"),
                where("siumId", "==", params.siumId)
            );
            const backupSnapshot = await getDocs(backupQuery);

            // Filter users based on haluka type
            const mappingField = siumHaluka === 'dapim' ? 'pages' : 'masehtot';
            const filteredUsers = backupSnapshot.docs
                .map(doc => ({ ...doc.data(), backupId: doc.id }))
                .filter(user => user[mappingField] !== undefined);

            setBackupUsers(filteredUsers);
        } catch (error) {
            console.error("Error fetching backup users:", error);
        }
    };

    // Restore backup users to users collection
    const restoreBackupUsers = async () => {
        if (backupUsers.length === 0) return;

        setIsRestoringBackup(true);
        const restoredCount = backupUsers.length;

        try {
            for (const backupUser of backupUsers) {
                // Get the original userId (which is the backup document ID)
                const { backupId, ...userData } = backupUser;

                // Restore to users collection with the original ID
                const userDocRef = doc(db, "users", backupId);
                await setDoc(userDocRef, {
                    ...userData,
                    restoredFromBackup: true,
                    restoredDate: new Date().getTime()
                });
            }

            // Delete backup users after successful restore
            for (const backupUser of backupUsers) {
                const backupDocRef = doc(db, "usersBackup", backupUser.backupId);
                await deleteDoc(backupDocRef);
            }

            // Clear backup users from state after successful restore
            setBackupUsers([]);

            // Show success message
            setErrorMessage(`שוחזרו ${restoredCount} לומדים בהצלחה!`);
            const errorToast = document.getElementById('errorModal');
            if (errorToast) {
                const toast = new window.bootstrap.Toast(errorToast);
                toast.show();
            }
        } catch (error) {
            console.error("Error restoring backup users:", error);
            setErrorMessage("שגיאה בשחזור הלומדים");
            const errorToast = document.getElementById('errorModal');
            if (errorToast) {
                const toast = new window.bootstrap.Toast(errorToast);
                toast.show();
            }
        } finally {
            setIsRestoringBackup(false);
        }
    };

    if (sium && sium.kehilaName) {

        return (
            <div className="sium-main edit-sium">
                <div className="sium-main-container">
                    <div className="basad-with-return margin-bottom-10">
                        <div className="basad">
                            <span>בס"ד</span>
                            <br/>
                            <span>להצלחת עם ישראל</span>
                        </div>
                        <div className="return-container">
                            <a className="btn sium-button return-button" href={"/niulSium/" + params.siumId + "/siumStatus"}>חזור</a>
                        </div>
                    </div>
                    <div className="sium-logo">
                        <a className="sium-logo-img" href={"/niulSium/" + params.siumId + "/siumStatus"} aria-label="Main page"></a>
                    </div>
                    <div className="grid p-3 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-3 sium-titles">
                        <h2>סיום הש"ס של {sium.kehilaName}</h2>
                        <h4>עריכת פרטי סיום הש"ס</h4>
                    </div>

                    {/* Restore backup users button */}
                    {backupUsers.length > 0 && !haveChanges && !isLoading && (
                        <div className="sium-button-container margin-top-20">
                            {!isRestoringBackup ? (
                                <button
                                    type="button"
                                    className="btn sium-button"
                                    onClick={restoreBackupUsers}
                                >
                                    שחזור {backupUsers.length} לומדים מגיבוי
                                </button>
                            ) : (
                                <button type="button" className="btn sium-button">
                                    <div className="updateStatusSpinner"></div>
                                </button>
                            )}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="needs-validation margin-top-20" noValidate>
                        <div className="form-floating">
                            <input className="form-control" type="text" id="kehilaNameInput" name="kehilaName" aria-label="Organization Name"
                                   required={true} defaultValue={sium.kehilaName} onChange={() => setHaveChanges(true)}/>
                            <label className="edit-sium-field" htmlFor="kehilaNameInput">שם הקהילה/הארגון</label>
                        </div>
                        <div className="form-floating">
                            <input className="form-control" type="text" id="organizerNameInput" name="fullName" aria-label="Organizer Name"
                               required={true} defaultValue={sium.organizerName} onChange={() => setHaveChanges(true)}/>
                            <label className="edit-sium-field" htmlFor="organizerNameInput">שם מנהל סיום השס</label>
                        </div>

                        <div className="phone-with-country">
                            <div className="form-floating phone-input-container">
                                <input className="form-control right-text" type="tel" id="phoneInput" name="phone" aria-label="Phone"
                                       required={true} value={phone} onChange={handlePhoneChange}/>
                                <label className="edit-sium-field" htmlFor="phoneInput">פלאפון</label>
                            </div>
                            <div className="country-selector" ref={countryDropdownRef}>
                                <div
                                    className="custom-country-dropdown"
                                    onClick={() => setIsCountryDropdownOpen(!isCountryDropdownOpen)}
                                >
                                    <div className="custom-country-selected">
                                        <CountryFlag countryCode={selectedCountry.code} className="country-flag-icon" />
                                        <span className="country-name-text">{selectedCountry.name}</span>
                                        <span className="dropdown-arrow">{isCountryDropdownOpen ? '▲' : '▼'}</span>
                                    </div>
                                </div>
                                {isCountryDropdownOpen && (
                                    <div className="custom-country-list">
                                        {countries.map(country => (
                                            <div
                                                key={country.code}
                                                className={`custom-country-item ${selectedCountry.code === country.code ? 'selected' : ''}`}
                                                onClick={() => handleCountrySelect(country)}
                                            >
                                                <CountryFlag countryCode={country.code} className="country-flag-icon" />
                                                <span className="country-name-text">{country.name}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                <input
                                    className="phone-prefix"
                                    type="text"
                                    value={phonePrefix}
                                    onChange={handlePrefixChange}
                                    aria-label="Phone prefix"
                                    placeholder="קידומת"
                                />
                            </div>
                        </div>

                        <div className="form-floating">
                            <input className="form-control" type="email" id="emailInput" name="email" aria-label="Email"
                               required={true} defaultValue={sium.organizerEmail} onChange={() => setHaveChanges(true)}/>
                            <label className="edit-sium-field" htmlFor="emailInput">אימייל</label>
                        </div>
                        <div className="form-floating">
                            <input className="form-control" type="text" id="nishmatInput" name="nishmat"
                               aria-label="Nishmat" defaultValue={sium.nishmat} onChange={() => setHaveChanges(true)}/>
                            <label className="edit-sium-field" htmlFor="nishmatInput">לעילוי נשמת/לרפואת/להצלחת</label>
                        </div>
                        <div className="input-container full-width halukat-shas-container margin-top-20">
                            <label className="halukat-shas-label font-size-20">חלוקת הש"ס לפי</label>
                            <div className="btn-group halukat-shas" role="group" aria-label="Basic radio toggle button group">
                                <input type="radio" className="btn-check" value="masehtot" id="halukatMasehtot" checked={haluka === 'masehtot'}
                                       onChange={(e) => {setHaluka(e.target.value); setHaveHalukaChanges(true)}}
                                       data-bs-toggle="modal" data-bs-target="#changeHalukatShas"/>
                                <label className="btn btn-outline-primary haluka-button" htmlFor="halukatMasehtot">מסכתות / פרקים</label>

                                <input type="radio" className="btn-check" value="dapim" checked={haluka === 'dapim'} id="halukatDapim"
                                       onChange={(e) => {setHaluka(e.target.value); setHaveHalukaChanges(true)}}
                                       data-bs-toggle="modal" data-bs-target="#changeHalukatShas"/>
                                <label className="btn btn-outline-primary haluka-button" htmlFor="halukatDapim">דפים</label>
                            </div>
                        </div>
                        <div className="input-container full-width halukat-shas-container">
                            <label className="halukat-shas-label font-size-20">בחר האם לכלול מסכתות</label>
                            <div className="btn-group halukat-shas" role="group" aria-label="what masahtot should include">

                                <input type="checkbox" className="btn-check" id="shkalim" autoComplete="off" checked={includeMasehtot.shkalim} onChange={(e) => handleIcludeMasehtot(e)}/>
                                <label className="btn btn-outline-primary include-masehet-button font-size-20" htmlFor="shkalim">שקלים</label>

                                <input type="checkbox" className="btn-check" id="kanim" autoComplete="off" checked={includeMasehtot.kanim} onChange={(e) => handleIcludeMasehtot(e)}/>
                                <label className="btn btn-outline-primary include-masehet-button font-size-20" htmlFor="kanim">קנים</label>

                                <input type="checkbox" className="btn-check" id="tamid" autoComplete="off" checked={includeMasehtot.tamid} onChange={(e) => handleIcludeMasehtot(e)}/>
                                <label className="btn btn-outline-primary include-masehet-button font-size-20" htmlFor="tamid">תמיד</label>

                                <input type="checkbox" className="btn-check" id="midot" autoComplete="off" checked={includeMasehtot.midot} onChange={(e) => handleIcludeMasehtot(e)}/>
                                <label className="btn btn-outline-primary include-masehet-button font-size-20" htmlFor="midot">מדות</label>
                            </div>
                        </div>
                        <div className="input-container full-width halukat-shas-container">
                            <label className="halukat-shas-label font-size-20">האם להוסיף משניות ללא גמרא</label>
                            <div className="btn-group halukat-shas" role="group" aria-label="Sould include Mishna without Gmara">
                                <input type="radio" className="btn-check" value="no" id="withoutMishna" checked={!mishna}
                                       onChange={() => {handleMishnaChange('no')}}/>
                                <label className="btn btn-outline-primary haluka-button font-size-20" htmlFor="withoutMishna">לא</label>

                                <input type="radio" className="btn-check" value="yes" checked={mishna} id="withMishna"
                                       onChange={() => {handleMishnaChange('yes')}}/>
                                <label className="btn btn-outline-primary haluka-button font-size-20" htmlFor="withMishna">כן</label>
                            </div>
                        </div>
                        {haluka === 'masehtot' && <div className="input-container full-width halukat-shas-container">
                            <label className="halukat-shas-label font-size-20">האם להסתיר פרטי הלומדים במצב תצוגת הש"ס</label>
                            <div className="btn-group halukat-shas" role="group" aria-label="Sould include Mishna without Gmara">
                                <input type="radio" className="btn-check" value="no" id="displayLomdim" checked={!hideLomdim}
                                       onChange={() => {handleHideLomdimChange('no')}}/>
                                <label className="btn btn-outline-primary haluka-button font-size-20" htmlFor="displayLomdim">לא</label>

                                <input type="radio" className="btn-check" value="yes" checked={hideLomdim} id="hideLomdim"
                                       onChange={() => {handleHideLomdimChange('yes')}}/>
                                <label className="btn btn-outline-primary haluka-button font-size-20" htmlFor="hideLomdim">כן</label>
                            </div>
                        </div>}
                        <div className="sium-dates-container">
                            <label className="bold">תאריך תחילת הלימוד</label><br/>
                            <HebrewDatePicker
                                selectsStart
                                selected={startDate}
                                onChange={date => {setStartDate(date);setHaveChanges(true)}}
                                startDate={startDate}
                                placeholder="בחר תאריך התחלה"
                            />
                            <br/>
                            <label className="bold">תאריך סיום הלימוד</label><br/>
                            <HebrewDatePicker
                                selectsEnd
                                selected={endDate}
                                onChange={date => {setEndDate(date);setHaveChanges(true)}}
                                endDate={endDate}
                                startDate={startDate}
                                minDate={startDate}
                                placeholder="בחר תאריך סיום"
                            />
                        </div>

                        <div className="toast-container position-fixed top-0 start-50 translate-middle-x">
                            <div id="errorModal" className="toast" role="alert" aria-live="assertive" aria-atomic="true"
                                 data-bs-autohide="true" data-bs-delay="3000">
                                <button type="button" className="btn-close me-2 m-auto" data-bs-dismiss="toast"
                                        aria-label="Close"></button>
                                <div className="toast-body">
                                    {errorMessage}
                                </div>
                            </div>
                        </div>

                        <div className="modal fade" id="changeHalukatShas" tabIndex="-1" aria-labelledby="change Haluka of the shas"
                             aria-hidden="true">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h1 className="modal-title fs-5">מחיקת כל הלומדים</h1>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal"
                                                aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body">
                                        <span>שינוי שיטת חלוקת הש"ס תמחק את כל הלומדים במערכת</span>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal"
                                                onClick={() => {setHaluka(sium.haluka || 'masehtot'); setHaveHalukaChanges(false)}}>ביטול
                                        </button>
                                        <button type="button" className="btn btn-primary" data-bs-dismiss="modal"
                                                onClick={() => setHaveChanges(true)}>אישור
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {haveChanges && <div className="sium-button-container sticky-bottom">
                            <button className="btn sium-button" type="submit">עדכן</button>
                        </div>}
                        {isLoading && <div className="sium-button-container sticky-bottom">
                            <button type="button" className="btn sium-button">
                                <div className="updateStatusSpinner"></div>
                            </button>
                        </div>}

                    </form>
                    <div className="sium-bottom-page margin-top-20">
                        <p><span> © כל הזכויות שמורות לאתר סיום הש"ס</span></p>
                    </div>
                </div>
            </div>
        )
    } else {
        return (<Spinner/>);
    }

}

export default EditSium;
